import { default as MD5 } from "md5";
import { gt, bb, _ } from "$json";
/* tabs:
 *
 * Show or hide tabs depending
 * on the model author info.
 * Also set the iFrame src.
 *
 * Author: Tim Bauwens
 * Copyright 2017 Berkeley Bridge
 *
 */

(function ($, doc, win) {
  $(function () {
    var translations = {
      "hide tabs": {
        en: "hide tabs",
        nl: "verberg tabbladen"
      },
      "show tabs": {
        en: "show tabs",
        nl: "toon tabbladen"
      }
    };

    $(function () {
      gt.addTranslations(translations);
    });

    var article = $("#bb-p-tab-content-audit div"); // div for document container on this page
    var _textURL; // which document?
    var _outside = false;
    var md5s = [];

    function reload() {
      bb.Mode.set("hasText");
      bb.Mode.set("hasTextInside");

      if (!_outside) {
        bb.Mode.set("hasTextInside");
        _textURL =
          "report?dbname=" +
          bb.getVar("dbname") +
          "&sessionid=" +
          bb.getVar("sessionid") +
          "&uniqueid=" +
          bb.getVar("uniqueid") +
          "&template=report" +
          "&_nocache=" +
          new Date().getTime() +
          " .bb-path";
        article.load(_textURL, function () {
          article.prepend(
            '<button class="bb-p-preview-outside"' +
              ' title="' +
              _("open this preview in a new window") +
              '">↗</button>'
          );
          var snippets = article.find("h1,h2,h3,h4,h5,h6,p,ul");
          var tmpmd5s = [];
          var num = 0;
          $.each(snippets, function () {
            var md5 = MD5($(this).html());
            if ($.inArray(md5, md5s) == -1) {
              $(this).addClass("bb-p-preview-new");
              if (++num == 1) article.scrollTo(this);
            }
            tmpmd5s.push(md5);
          });
          md5s = tmpmd5s;
        });
      }
      if (_outside) {
        loadOutside();
      }
    }

    function loadOutside() {
      _outside = true;
      bb.Mode.unset("hasTextInside");
      article.empty();
      _textURL =
        "report?dbname=" +
        bb.getVar("dbname") +
        "&sessionid=" +
        bb.getVar("sessionid") +
        "&uniqueid=" +
        bb.getVar("uniqueid") +
        "&template=report" +
        "&_nocache=" +
        new Date().getTime();

      var w = window.open(
        _textURL,
        "Preview",
        "scrollbars=yes,resizable=yes",
        true
      );
      if (!w.closed)
        var watchClose = win.setInterval(function () {
          try {
            if (w.closed) {
              win.clearTimeout(watchClose);
              //Do something here...
              _outside = false;
              bb.Mode.set("hasTextInside");
              reload();
            }
          } catch (e) {
            return;
          }
        }, 200);
    }

    $(doc).on("click", ".bb-p-preview-outside", loadOutside);

    // add reload function to each navigatory action:
    $(doc).on("bb:postHandleData", function (event, data) {
      // The test /could/ of course look directly inside
      // data.groups[last].controls, but looking at the DOM
      // means less code for me. This does mean bb:preHandleData
      // would not work.
      if (data && data.groups && data.groups.length > 0) {
        reload();
      }
      if (
        (data && data.status && data.status === "logout successful") ||
        (data.models && data.models.length > 0)
      ) {
        bb.Mode.unset("hasText");
      }
    });
  });
  var $defaultTab,
    $returnTab,
    tabbing = false,
    layout = layout || {};
  layout = {
    current: {
      state: 0,
      autoPressed: false,
      busy: false,
      session: 0
    },
    reposition: function (state) {
      var $button = $(".bb-p-tabs-state-toggle"),
        $nav = $(".bb-p-tabs-nav"),
        $content = $(".bb-p-tabs-content"),
        columns = {
          $left: $("#bbq-column"),
          $mid: $("#jumplist-column"),
          $right: $("#tabs-column")
        };
      if (isNaN(state) || state === 0 || state === this.current.state) {
        return false;
      } else if (state === 1) {
        columns.$left.attr("class", "column column--5");
        columns.$mid.attr("class", "column column--2");
        columns.$right.attr("class", "column column--5");
        $nav.fadeIn(200);
        $content.fadeIn(200);
        $button.attr({
          "aria-pressed": "false",
          "aria-label": _("hide tabs")
        });
        this.current.autoPressed = false;
      } else if (state === 2) {
        columns.$left.attr("class", "column column--11-5");
        columns.$mid.attr("class", "column column--0");
        columns.$right.attr("class", "column column--0-5");
        $nav.fadeOut(200);
        $content.fadeOut(200);
        $button.attr({
          "aria-pressed": "true",
          "aria-label": _("show tabs")
        });
      } else if (state === 3) {
        columns.$left.attr("class", "column column--10");
        columns.$mid.attr("class", "column column--2");
        columns.$right.attr("class", "column column--0");
        $nav.fadeOut(200);
        $content.fadeOut(200);
        $button.attr({
          "aria-pressed": "true",
          "aria-label": _("show tabs")
        });
      } else if (state === 4) {
        columns.$left.attr("class", "column column--7");
        columns.$mid.attr("class", "column column--0");
        columns.$right.attr("class", "column column--5");
        $nav.fadeIn(200);
        $content.fadeIn(200);
        $button.attr({
          "aria-pressed": "false",
          "aria-label": _("hide tabs")
        });
        this.current.autoPressed = false;
      } else if (state === 5) {
        columns.$left.attr("class", "column column--11-5");
        columns.$mid.attr("class", "column column--0");
        columns.$right.attr("class", "column column--0-5");
        $nav.fadeOut(200);
        $content.fadeOut(200);
        $button.attr({
          "aria-pressed": "true",
          "aria-label": _("show tabs")
        });
      } else if (state === 6) {
        columns.$left.attr("class", "column column--12");
        columns.$mid.attr("class", "column column--0");
        columns.$right.attr("class", "column column--0");
        $nav.fadeOut(200);
        $content.fadeOut(200);
        $button.attr({
          "aria-pressed": "true",
          "aria-label": _("show tabs")
        });
      }
      this.current.state = state;
    },
    request: function (request) {
      var desired;
      if (this.current.busy) {
        setTimeout(function () {
          layout.request(request);
        }, 300);
        return false;
      } else if (request === "reset") {
        this.current.busy = true;
        desired = bb.Mode.get("hasTabs")
          ? bb.Mode.get("hasJumplist")
            ? 1
            : 4
          : bb.Mode.get("hasJumplist")
            ? 3
            : 6;
      } else if (request === "postChk--flag") {
        this.current.busy = true;
        // There is a flagged grid, so collapse if necessary
        desired = bb.Mode.get("hasTabs")
          ? bb.Mode.get("hasJumplist")
            ? 2
            : 5
          : bb.Mode.get("hasJumplist")
            ? 3
            : 6;
        if (/[2,5]/.test(this.current.state)) {
          this.current.autoPressed = this.current.autoPressed ? true : false;
        } else {
          this.current.autoPressed = true;
        }
      } else if (request === "postChk--noflag") {
        this.current.busy = true;
        /*
          There's no flag, but do we need to add the jumplist,
          and do we need to return the tabs from auto-collapsed pos.
          ??
        */
        // In case there was no jumplist, is there one now?
        if (/[4,5,6]/.test(this.current.state) && bb.Mode.get("hasJumplist")) {
          // Minus 3 always results in the appropriate state plus jumplist.
          desired = this.current.state - 3;
        } else if (
          /[2,5]/.test(this.current.state) &&
          this.current.autoPressed
        ) {
          // Is it collapsed, and was that automatic originally?
          // Minus 1 always results in the appropriate 'open' position.
          desired = this.current.state - 1;
        } else {
          // Nothing to do.
          desired = this.current.state;
        }
      } else if (request === "user-toggle") {
        if (/[1,4]/.test(this.current.state)) {
          desired = this.current.state + 1;
        } else if (/[2,5]/.test(this.current.state)) {
          desired = this.current.state - 1;
        }
      }
      this.reposition(desired);
      setTimeout(function () {
        layout.current.busy = false;
      }, 250);
    }
  };
  function srcToggle(requestedSRC) {
    var currentSRC = $("#bb-p-tabs-iframe").attr("src"),
      defaultSRC = $("#bb-p-tabs-iframe").data("defaultSRC");
    if (requestedSRC === "default") {
      if (defaultSRC == "(unknown)" || defaultSRC == undefined) {
        $("#bb-p-tabs-iframe").attr("src", "#");
        bb.Mode.unset("hasIframe");
        return false;
      }
      requestedSRC = defaultSRC;
    }
    if (requestedSRC === currentSRC) {
      return false;
    } else {
      bb.Mode.set("hasIframe");
      $("#bb-p-tabs-iframe").attr("src", requestedSRC);
    }
  }
  function tabToggle($tab) {
    if (tabbing) {
      setTimeout(function () {
        tabToggle($tab);
      }, 500);
    } else {
      tabbing = true;
      var currentTab = $("#bb-p-tabs-pane nav button.showing").data("tab");
      var requestedTab = $tab.data("tab");
      if (currentTab === requestedTab) {
        tabbing = false;
        return false;
      } else {
        $("#bb-p-tabs-pane nav button")
          .removeClass("showing")
          .attr("aria-selected", "false");
        $tab.addClass("showing").attr("aria-selected", "true");
        var $tabContent = $("#" + requestedTab);
        $(".bb-p-tabs-tab").toggle(false);
        $tabContent.slideToggle(75, function () {
          tabbing = false;
        });
      }
    }
  }
  $(doc).ready(function () {
    $("button.bb-p-tabs-state-toggle").on("click touchend", function () {
      layout.request("user-toggle");
    });
  });
  $(doc).on("bb-p:modelinfo", function (e, model) {
    if (model && model.model) {
      if (model.model["tab-state"] === "on") {
        bb.Mode.set("hasTabs");
        bb.Mode.unset("hasIframe");
        $("#bb-p-tabs-pane nav button")
          .off("click.tabs")
          .each(function (i, v) {
            $(v).on("click.tabs", function () {
              tabToggle($(v));
            });
          });
        $.each(model.model, function (k, v) {
          if (k === "tab-name-iframe") {
            $('[data-tab="bb-p-tab-content-iframe"]').html(v);
          } else if (k === "tab-name-previews") {
            $('[data-tab="bb-p-tab-content-previews"]').html(v);
          } else if (k === "tab-name-informatie") {
            $('[data-tab="bb-p-tab-content-informatie"]').html(v);
          } else if (k === "tab-name-audit") {
            $('[data-tab="bb-p-tab-content-audit"]').html(v);
          }
        });
        if (model.model["tab-iframe"]) {
          $("#bb-p-tabs-iframe").data("defaultSRC", model.model["tab-iframe"]);
          bb.Mode.set("hasIframe");
        }
        if (model.model["tab-default"]) {
          if (model.model["tab-default"] === "informatie") {
            window.console &&
              window.console.warn(
                "'Informatie' cannot be the default tab, reverting to 'Audit Trail'"
              );
            $defaultTab = $('[data-tab="bb-p-tab-content-audit"]');
          } else {
            $defaultTab = $(
              '[data-tab="bb-p-tab-content-' + model.model["tab-default"] + '"]'
            );
          }
          if ($defaultTab.length <= 0) {
            window.console &&
              window.console.warn(
                "Default tab is not present: " + model.model["tab-default"]
              );
            window.console &&
              window.console.log(
                "%c tab-default: values cannot have leading or trailing whitespace.",
                "background: #172a63; color: white; font-weight: bold"
              );
            window.console &&
              window.console.log(
                "%c Allowed values are: informatie | audit | iframe | previews",
                "background: #172a63; color: white; font-weight: bold"
              );
            $defaultTab = $('[data-tab="bb-p-tab-content-audit"]');
          }
        } else {
          $defaultTab = $('[data-tab="bb-p-tab-content-audit"]');
        }
        $defaultTab.click();
      } else {
        bb.Mode.unset("hasTabs");
      }
      layout.request("reset");
    }
  });
  $(doc).on("bb:preHandleData", function (e, data) {
    if (data.informationsources) {
      var requestedSRC = "default",
        flag = false;
      $.each(data.informationsources, function (index, src) {
        if (src.isurl && !src.external) {
          requestedSRC = src.content;
          flag = index;
        }
      });
      (flag || flag === 0) && data.informationsources.splice(flag, 1);
      setTimeout(function () {
        srcToggle(requestedSRC);
      }, 500);
    }
  });
  $(doc).on("bb:postHandleData", function (event, data) {
    if (data && data.groups) {
      if (layout.current.session !== data.sessionid) {
        layout.request("reset");
        layout.current.session = data.sessionid;
      }
      var flag = false;
      $("#bbq-column table").each(function () {
        var width = $(this).width();
        if (width > $("#bbq-column").width()) {
          flag = true;
        } else {
          /*
            Grid is small enough to fit in - but
            is that because the tabs are currently
            collapsed? If we send no flag and they
            are collapsed, they will un-collapsed
            potentially swuashing the grid.
          */
          if (/[2,5]/.test(layout.current.state)) {
            /*
              The tabs are collapsed.
              If the state is 5, the un-collapsed
              state will be 4, and the ratio
              of current width to un-collapsed
              width is  1:0.61 (11.5/12 : 7/12)

              If the state is 2, the un-collapsed
              state will be 1, and the ratio
              of current width to un-collapsed
              width is  1:0.44 (11.5/12 : 5/12)
            */
            var ratio = layout.current.state === 5 ? 0.61 : 0.44;
            var potentialWidth = $("#bbq-column").width() * ratio;
            if (width > potentialWidth) flag = true;
          }
        }
      });
      setTimeout(function () {
        if (flag) {
          layout.request("postChk--flag");
        } else {
          layout.request("postChk--noflag");
        }
      }, 500);
      /*
        On every action, check if there is info sources, and show,
        but save the current showing tab, so we can go back later.
      */
      if (data.informationsources) {
        var nodeinfoflag = false;
        $.each(data.informationsources, function (i, source) {
          if (
            source.description.substring(9, 0) === "Nodeinfo:" &&
            !source.isurl
          ) {
            delete source.belongsto;
            nodeinfoflag = true;
          }
        });
      }
      if (nodeinfoflag && data.informationsources.length > 0) {
        if (
          $(".bb-p-tabs-nav button.showing").attr("id") ===
          "bb-p-tab-toggle-informatie"
        ) {
          return;
        } else {
          setTimeout(function () {
            var returnID = $(".bb-p-tabs-nav button.showing").attr("id");
            $returnTab = $("#" + returnID);
            $('[data-tab="bb-p-tab-content-informatie"]').click();
          }, 800);
        }
      } else {
        /*
          Ok, there's no info source in this node, so we best
          try to revert to the tab which was $returnTab showing before,
          and if that's not there anymore, use the $defaultTab.
        */
        if (
          $(".bb-p-tabs-nav button.showing").attr("id") !==
          "bb-p-tab-toggle-informatie"
        ) {
          return; // We weren't showing the info tab anyway, no need to do anything.
        } else {
          if ($returnTab && !$returnTab.prop("hidden")) {
            $returnTab.click();
          } else {
            $defaultTab =
              $defaultTab || $('[data-tab="bb-p-tab-content-audit"]');
            $defaultTab.click();
          }
        }
      }
    }
  });
})(jQuery, document, window);
